import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
    name: string;
    warn?: string;
}

@Component({
    selector: 'app-deleted-dialog',
    templateUrl: './deleted-dialog.component.html',
    styleUrls: ['./deleted-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeletedDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<DeletedDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
    ) {}

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        this.dialogRef.close(true);
    }
}
